import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=0e315fa1&"
import script from "./DefaultLayout.vue?vue&type=script&lang=js&"
export * from "./DefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e315fa1')) {
      api.createRecord('0e315fa1', component.options)
    } else {
      api.reload('0e315fa1', component.options)
    }
    module.hot.accept("./DefaultLayout.vue?vue&type=template&id=0e315fa1&", function () {
      api.rerender('0e315fa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth/src/layouts/DefaultLayout.vue"
export default component.exports